import styles from "./Link.module.scss";
import PropTypes from "prop-types";
import { Link as NLink } from "../DependencyHelper";

const Link = ({ href, text, clickHandler, prefetch,className }) => {
  return (
    <NLink legacyBehavior href={href} prefetch={prefetch}>
      <a className={`${styles.link} ${className}`} onClick={clickHandler}>
        {text}
      </a>
    </NLink>
  );
};

Link.defaultProps = {
  href: "",
  text: "",
  prefetch: true,
};
Link.propTypes = {
  href: PropTypes.string,
  text: PropTypes.string,
  clickHandler: PropTypes.func,
  prefetch: PropTypes.bool,
  className:PropTypes.any
};

export default Link;
